module.exports = __webpack_public_path__ + "826ce642f2b7b0b74041e6c5f09ba6e0.png";